import $ from 'jquery';
import 'foundation-sites';
import {Cookie} from '../helper/cookie';

export class Location {
    constructor(isMobile = false) {
        this.isMobile = isMobile;
        this.$cityConfirmation = $('#city-confirmation');
        this.$cityChanger = $('#city-changer');
        this.currentBranchSlug = this.$cityChanger.data('zfPlugin').$anchor.data('slug');
        this.cookie = new Cookie();
    }

    init() {
        this.events();
        let branchSlug = this.cookie.getCookie('branch_slug');
        if (!branchSlug || this.currentBranchSlug !== branchSlug) {
            this.$cityConfirmation.foundation('open');
        }
    }

    events() {
        this.$cityConfirmation
            .on('click', '.btn-yes', this.handlerClickBtnYes.bind(this))
            .on('click', '.btn-no', this.handlerClickBtnNo.bind(this))
        ;
        this.$cityChanger
            .on('open.zf.reveal', this.handlerOpenReveal.bind(this))
            .on('click', '[data-slug]', this.handlerClickBranchSlug.bind(this))
        ;
    }

    handlerClickBtnYes(event) {
        this.$cityConfirmation.foundation('close');
        let $self = $(event.currentTarget);
        this.cookie.setCookie('branch_slug', $self.data('slug'), {'max-age': 2592000});
    }

    handlerClickBtnNo() {
        this.$cityConfirmation.foundation('close');
        this.$cityChanger.foundation('open');
    }

    handlerOpenReveal() {
        this._setActiveBranchSlug(this.currentBranchSlug);
        navigator.geolocation.getCurrentPosition(position => {
            let {latitude, longitude} = position.coords;
            Location.getByPosition(latitude, longitude).then(data => {
                let {slug} = data;
                this._setActiveBranchSlug(slug);
            });
        });
    }

    handlerClickBranchSlug(event) {
        let $self = $(event.currentTarget);
        this.cookie.setCookie('branch_slug', $self.data('slug'), {'max-age': 2592000});
    }

    static async getByPosition(latitude, longitude) {
        const data = {
            latitude: latitude,
            longitude: longitude,
        };
        const response = await fetch('/q/location_by_position', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
        });
        return await response.json();
    }

    _setActiveBranchSlug(slug) {
        this.$cityChanger
            .find('.text-brand').removeClass('text-brand').end()
            .find(`[data-slug="${slug}"]`).addClass('text-brand').end()
        ;
    }
}
